<script setup lang="ts">
import type { JSX } from '@ionic/core'

const props = withDefaults(defineProps<JSX.IonItem>(),
	{
		lines: 'full',
	})
</script>

<template>
	<ion-item
		v-bind.attr="$attrs"
		v-bind.prop="props"
	/>
</template>

<style lang="scss" scoped>
ion-item {
	--min-height: 45px;
	--border-color: var(--ion-color-grey-5);
}
</style>
